var map = {
	"./Vector.svg": 990,
	"./android.svg": 991,
	"./difficulty-english.svg": 992,
	"./down-swirly.svg": 454,
	"./graphic.svg": 993,
	"./komal.svg": 994,
	"./language.svg": 995,
	"./learn-python.svg": 996,
	"./linkedin.svg": 997,
	"./misc.svg": 998,
	"./never-typed.svg": 999,
	"./playstore.svg": 597,
	"./python.svg": 1000,
	"./residential.svg": 1001,
	"./twitter.svg": 1002,
	"./typing.svg": 1003,
	"./web-development.svg": 1004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 596;